<h1 mat-dialog-title>ADD PROFILE</h1>
<div mat-dialog-content>  
  <mat-form-field>
    <mat-label>Name</mat-label>
    <input matInput [(ngModel)]="data.name" required>
  </mat-form-field>
</div>
<div mat-dialog-actions>
 
  <button mat-button [mat-dialog-close]="data.name" color="primary" cdkFocusInitial >ADD</button>
  <button mat-button (click)="onNoClick()">CANCEL</button>
</div>